export default theme => ({
  tag:{
    "& .MuiTableCell-paddingCheckbox": {
      backgroundColor: "blue !important"
    },
    "& .MuiTableCell-paddingCheckbox:last-child": {
      backgroundColor: "blue !important"
    },
    "& .MTableHeader-header-246":{
      backgroundColor: "blue !important"
    },
    "& .MuiTableCell-paddingCheckbox":{
      backgroundColor: "blue !important"
    }
  },
});
